import React, { useState } from "react";
import { Grid2 } from "@mui/material";
import GraphPeriodStyle from "../GraphPeriods/GraphPeriodStyle.module.scss";

const GraphPeriods = ({onPeriodChange}) => {
  const [selectedPeriod, setSelectedPeriod] = useState("Day");

  const handleClick = (period) => {
    setSelectedPeriod(period);
    onPeriodChange(period);
  };

  return (
    <Grid2 className={GraphPeriodStyle.container}>
      <Grid2
        className={`${GraphPeriodStyle.period} ${selectedPeriod === "Day" ? GraphPeriodStyle.active : ""}`}
        onClick={() => handleClick("Day")}
      >
        Day
      </Grid2>
      <Grid2
        className={`${GraphPeriodStyle.period} ${selectedPeriod === "Week" ? GraphPeriodStyle.active : ""}`}
        onClick={() => handleClick("Week")}
      >
        Week
      </Grid2>
      <Grid2
        className={`${GraphPeriodStyle.period} ${selectedPeriod === "Month" ? GraphPeriodStyle.active : ""}`}
        onClick={() => handleClick("Month")}
      >
        Month
      </Grid2>
    </Grid2>
  );
};

export default GraphPeriods;
